import { render, staticRenderFns } from "./marketing-campaign-index.vue?vue&type=template&id=13ecd131&"
import script from "./marketing-campaign-index.vue?vue&type=script&lang=ts&"
export * from "./marketing-campaign-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports